import React, { useEffect, useState, ViewTransition } from 'react';
import { View, Text, Image } from '../lib/react-native-compat';
import { useAtom } from 'jotai';
import SideMenu from './sideMenu';
import TopMenu from './topMenu';
import BidForecast from './bidForecast';
import LoadData from './loadData';
import LaborDashboard from './laborDashboard';
import LaborGraphs from './laborGraphs';
import LaborClassification from './laborClassification';
import ProductivityDashboard from './productivityDashboard';
import ProductivityCombined from './productivityCombined';
import Scorecard from './scorecard';
import SummaryOld from './summary';
import Overview from './overview';
import OverviewVoltaGrid from './overviewVoltaGrid';
import CostPlusForecast from './costPlusForecast';
import OverviewOld from './overviewOld';
import { isVoltaGridJob } from '../helpers/voltaGrid';
import Dashboard from './dashboard';
import DayZeroBudget from './dayZeroBudget';
import COLogOverview from './cologOverview';
import SummaryDashboard from './summaryDashboard';
import BurnTool from './burnTool';
import BurnToolPhased from './burnToolPhased';
import BurnToolEquipment from './burnToolEquipment';
import BurnToolPhasedEquipment from './burnToolPhasedEquipmentNew';
import Materials from './materials';
import Rentals from './rentals';
import Subcontractors from './subcontractors';
import Other from './other';
import Uncommitted from './uncommitted';
import PurchaseOrders from './purchaseOrders';
// import ProcurementDates from './procurementDates'; // Dates view hidden for now
import AllThirdParty from './allThirdParty';
import ThirdPartyCostDrivers from './thirdPartyCostDrivers';
import CostCurveForecast from './costCurveForecast';
import Contingency from './contingency';
import Admin from './admin';
import DataCleanup from './dataCleanup';
import PSRSlideJob from './psrSlideJob';
import Login from './login';
// import COLog from './colog';
// import BurnTool from './burnTool';
// import Billings from './billings';
// import OpenCommitmentsDetail from './openCommitmentsDetail';
// import OpenCommitmentsPivot from './openCommitmentsPivot';
// import CostHistoryPivot from './costHistoryPivot';
// import CostHistoryDetail from './costHistoryDetail';
// import Contingency from './contingency';
// import DayZeroBudget from './dayZeroBudget';
// import Scorecard from './scorecard';
// import Admin from './admin';
// import BurnToolEquipment from './burnToolEquipment';
// import Dashboard from './dashboard';
// import Projections from './projections';
import ProjectionsNew from './projectionsnew';
// import Settings from './settings';
//import LoadData from './loadData';
// import BurnToolPhased from './burnToolPhased';
// import BurnToolPhasedEquipment from './burnToolPhasedEquipment';
// import AdminPeople from './adminPeople';
// import PSRSlideJob from './psrSlideJob';
import RunProjections from './runProjections';
import JobTeam from './jobTeam';
import ProjectionSync from './projectionSync';
import AIChat from './aiChat';
import DataDiagnostics from './dataDiagnostics';
import CommunicationTools from './communicationTools';
import Backlog from './backlog';
import AuditLog from './auditLog';
import DailyFieldReport from './fieldReport';
import BaselineWeekly from './baselineWeekly';
import ScheduleStatus from './scheduleStatus';
import Billing from './billing';
import BillingDashboard from './billingDashboard';
import FieldReportsBoard from './fieldReportsBoard';
// import Procurement from './procurement';
// import TimeMaterialsReport from './timeMaterialsReport';
// import Login from './login'
import { loadVersionUnlocks, activeVersionUnlock, isUnlockActive } from '../db/versionUnlock';
import { loadTab, loadJob, loadTeam, loadVersion, loadJobDetails, loadSeenBefore, loadSelectedProjectManager, isProjectCoordinator, effectiveIsProjectCoordinator, pcAllowedTabs, allowedTabsForRole, setSelectedJobDetailsStorage } from '../db/company';
import moment from 'moment';
import { ErrorBoundary } from "react-error-boundary";
import cooltractor from '../assets/errorimage.png';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../authConfig';
import { jwtDecode } from 'jwt-decode';
// import Toast from 'react-native-toast-message'; // TODO: Replace with web-compatible toast
// import SummaryDashboard from './summaryDashboard';
// import LaborDashboard from './laborDashboard';
// import ThirdPartyDashboard from './thirdPartyDashboard';
// import ProductivityDashboard from './productivityDashboard';
// import Rentals from './rentals';
// import Subcontractors from './subcontractors';
// import Materials from './materials';
// import MaterialsNew from './materialsNew';
// import MaterialsNewNew from './materrialsNewNew';
// import DashboardNew from './dashboardNew';
// import Other from './other';
// import tractor from '../assets/tractor.png';
// import Overview from './overview';
// import JobHealth from './jobHealth';
// import Budgets from './budgets'
// import SetDates from './setDates';
// import Templates from './templates';
// import DashboardNewNew from './dashboardNewNew';

import {
  authStateAtom,
  phasedForecastAtom,
  selectedTeamAtom,
  selectedVersionAtom,
  selectedVersionLockedAtom,
  versionUnlocksAtom,
  selectedJobDataAtom,
  selectedJobAtom,
  jobUserDataAtom,
  seenBeforeAtom,
  dataSourceVersionAtom,
  selectedWIPAtom,
  isLiveVersionAtom,
  userIdAtom,
  userNameAtom,
  userEmailAtom,
  userEmailCheckAtom,
  userIsGoodAtom,
  userRoleAtom,
  previewRoleAtom,
  equipmentRatesAtom,
  dataSourceJobsAtom,
  dataSourceJobsClosedAtom,
  projectManagerAtom,
  jobLoadedAtom,
  liveForecast,
  selectedTab
} from '../store/company';

// standalone: render only the active tab's content (no side/top menu) — used
// by deep-link routes like /field-report.
const Main = ({ initialTab, standalone }) => {
  const { instance, accounts } = useMsal();
  const [auth, setAuth] = useAtom(authStateAtom);
  const [live, setLive] = useAtom(liveForecast);
  const [tab, setTab] = useAtom(selectedTab);
  const [phased, setPhased] = useAtom(phasedForecastAtom);
  const [selectedTeam, setSelectedTeam] = useAtom(selectedTeamAtom);
  const [selectedVersion, setSelectedVersion] = useAtom(selectedVersionAtom);
  const [versionLocked, setVersionLocked] = useAtom(selectedVersionLockedAtom);
  const [versionUnlocks, setVersionUnlocks] = useAtom(versionUnlocksAtom);
  const [selectedJobDetails, setSelectedJobDetails] = useAtom(selectedJobDataAtom);
  const [selectedJob, setSelectedJob] = useAtom(selectedJobAtom);
  const [jobUserData] = useAtom(jobUserDataAtom);
  const [seenBefore, setSeenBefore] = useAtom(seenBeforeAtom);
  const [tempSeen, setTempSeen] = useState(false);
  const [versions, setVersions] = useAtom(dataSourceVersionAtom);
  const [selectedWIP, setSelectedWIP] = useAtom(selectedWIPAtom);
  const [isLiveVersion, setIsLiveVersion] = useAtom(isLiveVersionAtom)
  const [userId, setUserId] = useAtom(userIdAtom);
  const [userName, setUserName] = useAtom(userNameAtom);
  const [userEmail, setUserEmail] = useAtom(userEmailAtom);
  const [userEmailCheck] = useAtom(userEmailCheckAtom);
  const [userIsGood, setUserIsGood] = useAtom(userIsGoodAtom)
  const [userRole] = useAtom(userRoleAtom);
  const [previewRole] = useAtom(previewRoleAtom);
  const [equipmentRates, setEquipmentRates] = useAtom(equipmentRatesAtom);
  const [dsJobs] = useAtom(dataSourceJobsAtom);
  const [jobsClosed, setJobsClosed] = useAtom(dataSourceJobsClosedAtom);
  const [selectedProjectManager, setSelectedProjectManager] = useAtom(projectManagerAtom)
  const [jobLoaded, setJobLoaded] = useAtom(jobLoadedAtom);
  const [authChecked, setAuthChecked] = useState(false);

  // Check for existing MSAL authentication on mount
  useEffect(() => {
    const checkExistingAuth = async () => {
      if (accounts.length > 0) {
        try {
          const response = await instance.acquireTokenSilent({
            ...loginRequest,
            account: accounts[0],
          });
          
          if (response.idToken && response.account) {
            const decoded = jwtDecode(response.idToken);
            setAuth({ idToken: response.idToken, decoded });
            
            // Set user information
            const email = response.account.username;
            const name = response.account.name || 'User';
            setUserId(email);
            setUserEmail(email);
            setUserName(name);
            
            // Check email domain authorization
            const emailDomain = email.split('@')[1];
            // boltcompanies.com: Pickett staff sign in with bolt UPNs (see login.tsx).
            const ALLOWED_DOMAINS = ['strikeusa.com', 'strike-llc.com', 'crossfire-llc.com', 'pickettsystems.com', 'mcleanscp.com', 'americanindustrial.com', 'boltcompanies.com'];
            setUserIsGood(ALLOWED_DOMAINS.includes(emailDomain));
          }
        } catch (error) {
          console.error('Silent token acquisition failed:', error);
        }
      }
      setAuthChecked(true);
    };
    
    checkExistingAuth();
  }, [accounts, instance]);

  useEffect(() => {
    loadSeenBefore().then((seen) => {
      setSeenBefore(seen)
    })

    // A deep-link route (e.g. /field-report) pins its tab; otherwise restore
    // the last tab the user had open.
    if (initialTab) {
      setTab(initialTab)
    } else {
      loadTab().then((tab) => {
        if (tab) setTab(tab)
      })
    }

    loadJob().then((job) => {
      setSelectedJob(job)
    })

    loadTeam().then((team) => {
      setSelectedTeam(team)
    })

    loadVersion().then((version) => {
      console.log('loaded version in main', version)
      setSelectedVersion(version)
    })

    loadJobDetails().then((job) => {
      setSelectedJobDetails(job)
    })

    loadSelectedProjectManager().then((pm) => {
      setSelectedProjectManager(pm)
    })
  }, [])

  // The job details restored above are a localStorage snapshot taken whenever
  // the job was last picked, so they can be missing columns the job query has
  // since added (e.g. Work_Type_Description, which the field report header
  // needs). Once the live job list lands, re-seed from its row for the selected
  // job — that row is the source of truth. Closed jobs aren't in the list, so
  // a miss leaves the stored snapshot alone.
  useEffect(() => {
    if (!selectedJob || !(dsJobs && dsJobs.length)) return
    const live = dsJobs.find((j) => j?.BU_ID === selectedJob)
    if (!live) return
    const stale = Object.keys(live).some(
      (k) => (selectedJobDetails?.[k] ?? null) !== (live[k] ?? null)
    )
    if (!stale) return
    const merged = { ...selectedJobDetails, ...live }
    setSelectedJobDetails(merged)
    setSelectedJobDetailsStorage(merged)
  }, [dsJobs, selectedJob])

  useEffect(() => {
    const WIPVersions = []
    let latestVersionDate = '2024-01-01'
    let latestVersionId = 0
    let highestVersion = 0
    versions && versions.forEach((version) => {
      if (highestVersion < version.Version_GUID) {
        highestVersion = version.Version_GUID
      }
    })

    // A PCL can lock this job's forecast on the live version after the meeting
    // (a 'versionLocked' row saved to user data). That freeze applies to
    // everyone, on top of the normal version-type / age based locking below.
    // The row's value is the Version_GUID the lock was placed on: the PSR copy
    // job carries the row forward with the NEW version's GUID but the old
    // version number as its value, so the mismatch leaves the new version
    // unlocked. Legacy rows that stored 'true' still count as locked.
    //
    // The PCL lock only bites on the live version — prior versions are already
    // locked by the base rule below, so there's nothing for it to add there.
    const hasJobLock = selectedVersion == highestVersion &&
      Array.isArray(jobUserData) && jobUserData.some(
        (d) => d.Forecast_Field_Name === 'versionLocked' &&
          (String(d.Forecast_Value) === 'true' || String(d.Forecast_Value) === String(selectedVersion))
      )

    // An admin can open a locked version back up for this job or all jobs
    // until the end of the day (db/versionUnlock.js). It lifts the base lock
    // below, never a PCL lock.
    const adminUnlock = activeVersionUnlock(versionUnlocks, selectedVersion, selectedJob)

    //set version locked
    versions && versions.forEach((version) => {
      if (version.Version_GUID == selectedVersion) {
        console.log('locked version', version.Version_Type, { hasJobLock })
        // Editable window: the live version only. Every prior version is
        // locked; on the live one only an explicitly 'locked' Version_Type
        // freezes it.
        const baseLock = selectedVersion >= highestVersion ? version.Version_Type.includes('locked') : true
        setVersionLocked((baseLock && !adminUnlock) || hasJobLock)
      }

      if (version.Version_Type == 'WIP' || version.Version_Type == 'WIP-hidden' || version.Version_Type == 'WIP-locked') {
        WIPVersions.push(version)
      }
      //console.log('WIPVersions - main', WIPVersions)

      if (moment(version.Version_Start_DateTime).isAfter(latestVersionDate)) {
        latestVersionDate = version.Version_Start_DateTime
        latestVersionId = version.Version_GUID
      }
    })
    //console.log('WIPVersions - main', WIPVersions)
    //let mostRecentWIP = WIPVersions[WIPVersions.length - 1]
    let mostRecentWIPBeforeSelected = null;
    WIPVersions.forEach((version) => {
      if (version.Version_GUID < selectedVersion && (!mostRecentWIPBeforeSelected || moment(version.Version_Start_DateTime).isAfter(mostRecentWIPBeforeSelected.Version_Start_DateTime))) {
        mostRecentWIPBeforeSelected = version;
      }
    });
    setSelectedWIP(mostRecentWIPBeforeSelected);
    //setSelectedWIP(WIPVersions[WIPVersions.length - 1])
    //console.log('latestVersionId - main', latestVersionId, selectedVersion)
    if (selectedVersion == latestVersionId) {
      setIsLiveVersion(true)
    } else {
      setIsLiveVersion(false)
    }
  }, [selectedVersion, versions, jobUserData, versionUnlocks, selectedJob])

  // Re-read the admin unlocks every minute, so an unlock or re-lock reaches
  // open sessions without a refresh and an unlock that ran out locks the
  // version again on time. Only open unlocks are kept, and the atom only
  // changes when that list does, so the app doesn't re-render every minute.
  useEffect(() => {
    let alive = true
    const keep = (next) => setVersionUnlocks((prev) =>
      JSON.stringify(prev) === JSON.stringify(next) ? prev : next)
    const refresh = () => loadVersionUnlocks()
      .then((u) => { if (alive) keep(u.filter((x) => isUnlockActive(x))) })
      .catch(() => { if (alive) setVersionUnlocks((prev) => {
        const open = prev.filter((x) => isUnlockActive(x))
        return open.length === prev.length ? prev : open
      }) })
    refresh()
    const timer = setInterval(refresh, 60000)
    return () => { alive = false; clearInterval(timer) }
  }, [selectedVersion, selectedJob])

  useEffect(() => {
    if (jobsClosed && jobsClosed.length && jobsClosed.find((job) => job.BU_ID == selectedJob)) {
      //setVersionLocked(true);
    }
  }, [selectedJob, jobsClosed]);

  // Project Coordinators and Buyers share the same restricted procurement view
  // (buyerAllowedTabs mirrors pcAllowedTabs). Identify by DB role OR the static
  // fallback list so the restriction holds even when only the login fallback is
  // working. Normalize the active tab so a stored/disallowed tab can never
  // render its content.
  const isPC = effectiveIsProjectCoordinator(previewRole, userRole, userEmail);
  const allowedTabs = allowedTabsForRole(previewRole, userRole, userEmail);

  // 'Schedule & Baseline' and 'Tracker Schedule' were folded into the one
  // Schedule tab. Their names are still in people's localStorage, and an
  // unrecognized tab renders nothing at all, so map them forward.
  const RETIRED_TABS = {
    'Schedule & Baseline': 'Baseline & Weekly',
    'Tracker Schedule': 'Baseline & Weekly',
    // Dates view hidden for now — send a stored 'Dates' tab to Uncommitted.
    'Dates': 'Uncommitted',
    // Overview - Old hidden for now — a stored tab goes to the regular Overview.
    'Overview - Old': 'Overview',
  };
  // Overview VoltaGrid and Cost Plus Forecast only exist on the VoltaGrid
  // jobs — a stored tab, or a job switch while one is open, falls back to
  // the regular Overview / Forecast.
  const retiredTab = RETIRED_TABS[tab] || tab;
  const VG_FALLBACK = { 'Overview VoltaGrid': 'Overview', 'Cost Plus Forecast': 'Forecast' };
  const currentTab = VG_FALLBACK[retiredTab] && !isVoltaGridJob(selectedJob) ? VG_FALLBACK[retiredTab] : retiredTab;
  const visibleTab = allowedTabs && !allowedTabs.includes(currentTab) ? allowedTabs[0] : currentTab;

  // Daily Field Report is still in progress — limit it to Seth and Steve for
  // now (matches the sideMenu guard, and keeps a stored selectedTab from
  // rendering the page for anyone else).
  const canSeeFieldReport = process.env.NODE_ENV !== 'production' || userId === '154045' || userEmailCheck === 'seth.bailey@strikeusa.com' || userEmailCheck === 'steve.horman@strikeusa.com' || userEmailCheck === 'steven.horman@strikeusa.com';
  // Job Team is still in progress — same Seth/Steve gate as the field report.
  const canSeeJobTeam = canSeeFieldReport;
  // Schedule & Baseline uploads — same WIP group as the sideMenu's WIP tabs.
  const canSeeSchedule = canSeeFieldReport || userEmailCheck === 'troy.wyles@strikeusa.com';

  return (
    <ErrorBoundary fallback={
      <View style={{ 
        flex: 1, 
        justifyContent: 'center', 
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#F5F7FA'
      }}>
        <View style={{ alignItems: 'center' }}>
          <Image 
            source={cooltractor} 
            style={{ width: 300, height: 'auto', marginBottom: 20 }}
            resizeMode="contain"
            alt="Error"
          />
          <Text style={{ fontSize: 18, color: '#333', textAlign: 'center' }}>
            An error occurred. Try refreshing.
          </Text>
        </View>
      </View>
    }>
      <LoadData />
      {!authChecked ? (
        <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', minHeight: '100vh', backgroundColor: '#F5F7FA' }}>
          <Text style={{ fontSize: 16, color: '#666' }}>Loading...</Text>
        </View>
      ) : (process.env.NODE_ENV !== 'production' || (auth && auth.idToken)) ? (
        userIsGood ? (
          <ViewTransition>
            {/* The side menu and the top bar stay put; only the page below the top bar
                scrolls (the scroll area, further down). Print undoes the fixed height. */}
            <View style={{ flexDirection: 'row', height: '100vh', backgroundColor: '#F5F7FA' }} data-print-shell="true">
              {!standalone && <SideMenu />}
              <View style={{ flex: 1, minWidth: 0, height: '100vh', backgroundColor: '#F5F7FA' }} data-print-content="true">
                {!selectedJob && (
                  <View style={{ backgroundColor: '#FEF3C7', borderBottomWidth: 1, borderBottomColor: '#F59E0B', paddingVertical: 6, paddingHorizontal: 12 }}>
                    <Text style={{ fontSize: 13, color: '#92400E', textAlign: 'center' }}>
                      Project info is loading — saves are blocked until it finishes.
                    </Text>
                  </View>
                )}
                {!standalone && <TopMenu />}
                {!standalone && previewRole && (
                  <View style={{ backgroundColor: '#ECFDF5', borderBottomWidth: 1, borderBottomColor: '#065F46', paddingVertical: 6, paddingHorizontal: 12 }}>
                    <Text style={{ fontSize: 13, color: '#065F46', textAlign: 'center', fontWeight: '600' }}>
                      Viewing as {previewRole} — you are seeing the restricted view. Use the switcher in the top menu to exit.
                    </Text>
                  </View>
                )}
                <View data-scroll-area="true" style={{ flex: 1, minHeight: 0, overflow: 'auto' }}>
                  {visibleTab === 'Dashboard' && <Dashboard />}
                  {visibleTab === 'Team Schedule' && <Dashboard />}
                  {visibleTab === 'Forecast' && <BidForecast />}
                  {visibleTab === 'Labor Dashboard' && <LaborDashboard />}
                  {visibleTab === 'Labor S Curve' && <LaborGraphs />}
                  {visibleTab === 'Labor Ratios' && <LaborClassification />}
                  {visibleTab === 'Productivity Tracker' && <ProductivityDashboard />}
                  {visibleTab === 'Productivity Combined' && <ProductivityCombined />}
                  {visibleTab === 'Scorecard' && <Scorecard />}
                  {visibleTab === 'Summary' && <SummaryDashboard />}
                  {visibleTab === 'T&M Summary' && <SummaryDashboard />}
                  {visibleTab === 'Overview' && <Overview />}
                  {visibleTab === 'Overview VoltaGrid' && <OverviewVoltaGrid />}
                  {visibleTab === 'Cost Plus Forecast' && <CostPlusForecast />}
                  {visibleTab === 'Overview - Old' && canSeeSchedule && <OverviewOld />}
                  {visibleTab === 'Day Zero Budget' && <DayZeroBudget />}
                  {visibleTab === 'CO Log' && <COLogOverview />}
                  {visibleTab === 'Burn Tool Labor' && (phased === 'phased' ? <BurnToolPhased /> : <BurnTool />)}
                  {visibleTab === 'Burn Tool Equipment' && (phased === 'phased' ? <BurnToolPhasedEquipment /> : <BurnToolEquipment />)}
                  {visibleTab === 'Materials' && <Materials />}
                  {visibleTab === 'Rentals' && <Rentals />}
                  {visibleTab === 'Subcontractors' && <Subcontractors />}
                  {visibleTab === 'Other' && <Other />}
                  {visibleTab === 'Uncommitted' && <Uncommitted />}
                  {/* Dates view hidden for now */}
                  {/* {visibleTab === 'Dates' && <ProcurementDates />} */}
                  {visibleTab === 'All Third Party' && <AllThirdParty />}
                  {visibleTab === 'Purchase Orders' && <PurchaseOrders />}
                  {visibleTab === '3rd Party Cost Drivers' && <ThirdPartyCostDrivers />}
                  {visibleTab === 'Revenue Curve Forecast' && <CostCurveForecast />}
                  {visibleTab === 'Contingency' && <Contingency />}
                  {visibleTab === 'Admin' && <Admin />}
                  {visibleTab === 'Data Cleanup' && <DataCleanup />}
                  {visibleTab === 'PSR Slides' && <PSRSlideJob />}
                  {visibleTab === 'Run Projections' && <RunProjections />}
                  {visibleTab === 'Projection Sync' && <ProjectionSync />}
                  {visibleTab === 'Projection Orch' && <ProjectionsNew />}
                  {visibleTab === 'AI Chat' && <AIChat />}
                  {visibleTab === 'Data Diagnostics' && <DataDiagnostics />}
                  {visibleTab === 'Comms Tools' && <CommunicationTools />}

                  {visibleTab === 'Backlog' && <Backlog />}
                  {visibleTab === 'Change History' && <AuditLog />}
                  {visibleTab === 'Daily Field Report' && canSeeFieldReport && <DailyFieldReport />}
                  {visibleTab === 'Daily Field Report 2' && canSeeFieldReport && <DailyFieldReport simple />}
                  {visibleTab === 'Job Team' && canSeeJobTeam && <JobTeam />}
                  {visibleTab === 'Baseline & Weekly' && canSeeSchedule && <BaselineWeekly />}
                  {visibleTab === 'Schedule Status' && canSeeSchedule && <ScheduleStatus />}
                  {visibleTab === 'Billing' && <Billing />}
                  {/* Trailer TV board — full-screen overlay, served on /billing-tv.
                      VoltaGrid Field reports by default; ?board=tickets keeps the
                      old crew & field ticket board. */}
                  {visibleTab === 'Billing TV' && (
                    new URLSearchParams(window.location.search).get('board') === 'tickets'
                      ? <BillingDashboard />
                      : <FieldReportsBoard />
                  )}
                </View>
              </View>
            </View>
          </ViewTransition>
        ) : (
          <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', minHeight: '100vh', backgroundColor: '#F5F7FA' }}>
            <Text style={{ fontSize: 20, color: '#d32f2f', marginBottom: 12 }}>Access Denied</Text>
            <Text style={{ fontSize: 16, textAlign: 'center', maxWidth: 500, color: '#666' }}>
              User is not authorized. Please sign in with your Strike USA email address.
            </Text>
            <Text style={{ fontSize: 14, marginTop: 8, color: '#999' }}>
              Contact Seth Bailey for access.
            </Text>
          </View>
        )
      ) : (
        <Login />
      )}
    </ErrorBoundary>
  );
};

export default Main;

      // <View style={{ backgroundColor: '#d3d3d3', minHeight: '100%' }}>
      //   {process.env.NODE_ENV != 'production' || auth && auth.idToken ? <View style={{ minHeight: '100%', backgroundColor: '#dee4e4' }}>
      //     <View style={{ flexDirection: 'row', minHeight: '100%', width: '100%' }}>
      //       {/* <SideMenu /> */}
      //       <View>
      //         {/* <LoadData /> */}
      //         {process.env.NODE_ENV != 'production' || userIsGood ? <View style={{ flexDirection: 'row', minHeight: '100%', backgroundColor: '#dee4e4' }}>
      //           {true/*jobLoaded == 'three'*/ ? <View style={{ borderRaius: 10, alignItems: 'flex-start', backgroundColor: '#dee4e4' }}>
      //             {/* {live == 'live' ?  */}
      //             {/* {tab == 'Summary' ? <SummaryDashboard/> : null} */}
      //             {tab == 'Forecast' ? <BidForecast/> : null}
      //             {/* {tab == 'CO Log' ? <COLog/> : null}
      //             {tab == 'Scorecard' ? <Scorecard/> : null}
      //             {phased == 'phased' && tab == 'Burn Tool Labor' ? <BurnToolPhased /> : tab == 'Burn Tool Labor' ? <BurnTool /> : null}
      //             {tab == 'Materials' ? <Materials type="materials" /> : null}
      //             {tab == 'Rentals' ? <Rentals type="rentals" /> : null}
      //             {tab == 'Subcontractors' ? <Subcontractors type="subcontractors" /> : null}
      //             {tab == 'Other' ? <Other type="other" /> : null}
      //             {tab == 'Overview' ? <Overview /> : null}
      //             {tab == 'Billings' ? <Billings /> : null}
      //             {tab == 'Contingency' ? <Contingency /> : null}
      //             {tab == 'Cost History - Pivot' ? <CostHistoryPivot /> : null}
      //             {tab == 'Cost History - Detail' ? <CostHistoryDetail /> : null}
      //             {tab == 'Open Commitments - Pivot' ? <OpenCommitmentsPivot /> : null}
      //             {tab == 'Open Commitments - Detail' ? <OpenCommitmentsDetail /> : null}
      //             {tab == 'PSR Slides' ? <PSRSlideJob /> : null}
      //             {tab == 'Templates' ? <Templates /> : null}
      //             {tab == 'Day Zero Budget' ? <DayZeroBudget /> : null}
      //             {tab == 'Admin' ? <Admin /> : null}
      //             {tab == 'Productivity Tracker' ? <ProductivityDashboard /> : null}
      //             {phased == 'phased' && tab == 'Burn Tool Equipment' ? <BurnToolPhasedEquipment /> : tab == 'Burn Tool Equipment' ? <BurnToolEquipment /> : null}
      //             {tab == 'Dashboard' ? <DashboardNewNew /> : null}
      //             {tab == 'Labor Dashboard' ? <LaborDashboard /> : null}
      //             {tab == 'Admin People' ? <AdminPeople /> : null}
      //             {tab == 'Run Projections' ? <RunProjections /> : null}
      //             {tab == 'Projections' ? <Projections /> : null}
      //             {tab == 'Procurement' ? <Procurement /> : null}
      //             {tab == 'Time Materials Report' ? <TimeMaterialsReport /> : null}
      //             {tab == 'Set Dates' ? <SetDates /> : null} */}
      //             {/* <Toast /> */}
      //           </View> : jobLoaded == true ? 
      //             <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', paddingLeft: 300 }}>
      //               {/* <Image source={tractor} style={{ width: 100, height: 100, marginBottom: 20 }} /> */}
      //               <Text style={{ fontSize: 20 }}>Loading job data...</Text>
      //             </View>
      //             : <Text>Loading....{jobLoaded} seth</Text>
      //           }
      //           {/* {live == 'analytics' ? <View style={{ marginTop: 50, flex: 1, alignItems: 'center' }}><Settings /></View> : null} */}
      //         </View> : <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', paddingLeft: 300 }}><Text style={{ fontSize: 20 }}>User is not authorized. Try using your strikeusa email. Contact Steve Horman.</Text></View>}
      //       </View>
      //     </View>
      //   </View> : <View style={{ flexDirection: 'row', minHeight: '100%', backgroundColor: '#d3d3d3' }}></View>}
      //   {/* <Login /> */}
      // </View>

